<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>招标市场</el-breadcrumb-item>
                <div class="right fr" @click="$router.back(-1)">
                    <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
                </div>
            </el-breadcrumb>
        </div>

        <div class="base-search-container">
            <div class="simple-search clearfix">
                <div class="clearfix fr">
                    <div class="search-container primary fl" style="width: 260px;">
                        <div class="form-box">
                            <input class="input-field" v-model="title" placeholder="请输入标题"/>
                            <button class="search-btn" @click.stop="getBidMarketList()"><i class="icon iconfont icon-search"></i></button>
                        </div>
                    </div>
                    <div v-if="!searchShow" class="advance-search-switch" @click="showSearch(true)"><span>更多筛选条件</span><i class="icon iconfont icon-down"></i>
                    </div>
                    <div v-if="searchShow" class="advance-search-switch" @click="showSearch(false)"><span>更多筛选条件</span><i class="icon iconfont icon-up"></i>
                    </div>
                </div>
            </div>
            <div v-if="searchShow" class="advanced-search  clearfix">
                <div class="fr">
                    <div class="search-form-row">
                        <div class="form-title">发布日期</div>
                        <div class="form-content" style="width: 340px">
                            <div>
                                <el-date-picker v-model="dateStart" type="date" placeholder="起始时间"></el-date-picker>
                                <span>--</span>
                                <el-date-picker v-model="dateEnd" type="date" placeholder="结束时间"></el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="search-form-row">
                        <div class="form-title">&nbsp;</div>
                        <div class="form-content">
                            <button @click.stop="getBidMarketList()" class="swb-btn">搜索</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="block-container">

            <table class="custom-tbl">
                <thead class="head">
                <tr class="row">
                    <th style="text-align: left">招标书标题</th>
                    <th>招标开始时间</th>
                    <th>招标结束时间</th>
                    <th>发布时间</th>
                    <th style="text-align: left">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="bidEnroll in bidEnrollList">
                    <td style="text-align: left">
                        <a class="swb-btn-link" @click="toCallBidDocInfo(bidEnroll.id,bidEnroll.openTime)">{{bidEnroll.title}}</a>
                    </td>
                    <td>{{bidEnroll.openTime}}</td>
                    <td>{{bidEnroll.closeTime}}</td>
                    <td>{{bidEnroll.publishTime}}</td>
                    <td style="text-align: left">
                        <div>
                            <a class="swb-btn-link" @click="lookNotice(bidEnroll.id)"> 查看招标书公告</a>
                            <a class="swb-btn-link" v-if="checkTime(bidEnroll.publishTime) && !checkTime(bidEnroll.enrollCloseTime) && bidEnroll.isEnroll==false" @click="signUpJudge(bidEnroll.id)">报名</a>
                            <a class="swb-btn-link" @click="toCallBidDocInfo(bidEnroll.id,bidEnroll.openTime)">查看详细信息</a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="pagination-layout">
                <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import callBidApi from '../../api/callBid'
    import tendBidApi from '../../api/tendBid'

    import SwbCallBidNoticeList from './CallBidNoticeList';
    Vue.regist(SwbCallBidNoticeList);

    import SwbBidEnrollSignUp from './BidEnrollSignUp';
    Routes.add(SwbBidEnrollSignUp);

    import SwbCallBidDocInfo from './CallBidDocInfo';
    Routes.add(SwbCallBidDocInfo);

    import SwbCkEditor from '../ctrl/CkEditor';
    Vue.regist(SwbCkEditor);

    export default{
        name: 'swb-bid-market-list',
        path: '/bid/market/fq/list',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '招标市场(已弃用)',
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                bidEnrollList: [],
                title: null,
                dateStart: null,
                dateEnd: null,
                searchShow: false,
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getBidMarketList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getBidMarketList();
            },

            searchTag: function (tag) {
                this.sndPartyFlag = tag;
                this.searchShow = true;
                this.getBidMarketList();
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },

            getBidMarketList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};
                //
                if(!Utils.isNoB(self.title)) {
                    filterItems.title = self.title;
                }
                if(!Utils.isNoB(self.dateStart)) {
                    filterItems.createTimeFrom = self.dateStart.format('yyyy-MM-dd HH:mm:ss');
                }
                if(!Utils.isNoB(self.dateEnd)) {
                    filterItems.createTimeTo = self.dateEnd.format('yyyy-MM-dd HH:mm:ss');
                }
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                callBidApi.getCallBidDocMarketList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.bidEnrollList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            lookNotice: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: '公告列表 - 查看',
                    showCloseBtn: true,
                    width: 900,
                    height: 700,
                    template: '<div>' +
                    '<swb-call-bid-notice-list :docId="docId" ref="swb_call_Bid_notice_list"></swb-call-bid-notice-list>' +
                    '</div>',
                    data: {
                        docId: id,
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    method: {},
                    lifecycle: {}

                });
            },
            // 报名前检查是否已经报名
            signUpJudge: function (callDocId) {
                let self = this;
                tendBidApi.checkBidEnroll(callDocId, function (result) {
                    if(result.type == 'info') {
                        self.signUp(callDocId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            signUp: function (callDocId) {  // 跳转到报名信息页
                this.$router.push({
                    path: BidEnrollSignUp.path,
                    query: {
                        callDocId: callDocId
                    }
                });
            },
            toCallBidDocInfo: function (callBidDocId, openTime) { // 跳转招标书详细信息界面
                this.$router.push({
                    path: CallBidDocInfo.path,
                    query: {
                        callBidDocId: callBidDocId,
                        resultFlag: false,
                        openTime: openTime,
                    }
                });
            },
            checkTime: function (time) {
                var currTime = new Date();
                var dbTime = new Date(time);

                if(currTime.getTime() >= dbTime.getTime()) {
                    return true;
                } else if(currTime.getTime() < dbTime.getTime()) {
                    return false;
                }
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/BidMarketList.vue